<!-- Registaration -->
<div class="registaration">
  <div class="r-header">
    <img src="../../../../assets/images/logo-dark.svg" alt="">
  </div>

  <div class="sidebar">
    <img src="../../../../assets/images/logo2.svg" class="logo" alt="">
    <h2>
      Create interactive contests, connect with your audience, and turn every action into lasting loyalty, all powered
      by LuQta.
    </h2>
    <img src="../../../../assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
  </div>
  <div class="form-body">
    <div class="cant-have-account">
      <a [href]="baseUrl" class="back-to-home">
        <i class="fa-solid fa-arrow-left"></i>
        <span>{{ 'login.go-to-home' | translate }}</span>
      </a>
      <div class="account">
        <span>
          {{ 'login.no-account' | translate }}
        </span>
        <a [routerLink]="'/auth/pricing'">
          {{ 'login.sign-up' | translate }}
        </a>
      </div>
    </div>
    <form class=" w-100" [formGroup]="LoginForm" (ngSubmit)="onSubmit()">
      <div class="form-card">
        <h3 class="title">
          {{ 'login.sign-in' | translate }}
        </h3>
        <!-- Email -->
        <div class="input-group  position-relative">
          <input type="email" class="form-control" formControlName="email" id="email"
            [placeholder]="'login.emailPlaceholder' | translate" />
          <div class="">
            <small class="error text-danger"
              *ngIf="LoginForm.controls['email'].invalid && LoginForm.controls['email'].touched">
              <span *ngIf="LoginForm.controls['email'].errors?.['required']">
                {{ 'login.emailRequired' | translate }}
              </span>
              <span *ngIf="LoginForm.controls['email'].errors?.['email']">
                {{ 'login.emailInvalid' | translate }}
              </span>
            </small>
          </div>
        </div>

        <!-- Password -->
        <div class="input-group  position-relative">
          <input [type]="isPasswordVisible ? 'text' : 'password'" id="password" class="form-control"
            formControlName="password" [placeholder]="'login.passwordPlaceholder' | translate" />
          <span (click)="togglePasswordVisibility()" style="cursor: pointer;">
            <i [ngClass]="isPasswordVisible ? 'fa -solid fa-eye' : 'fa -solid fa-eye-slash'"></i>
          </span>
          <div class="">
            <small class="error text-danger"
              *ngIf="LoginForm.controls['password'].invalid && LoginForm.controls['password'].touched">
              <span *ngIf="LoginForm.controls['password'].errors?.['required']">
                {{ 'login.passwordRequired' | translate }}
              </span>
            </small>
          </div>
        </div>

        <!-- Forgot password -->
        <a class="forgot-pass d-block" [routerLink]="'/auth/forgot'">
          {{ 'login.forgotPassword' | translate }}
        </a>

        <!-- Submit -->
        <button class="btn btn-primary btn-md w-100" type="submit">
          {{ 'login.loginButton' | translate }}
        </button>
        <!-- <div class="or">
          <div class="line"></div>
          <span>Or</span>
        </div> -->
        <!-- <div class="other-login-options">
          <div class="row">
            <div class="col-md-6">
              <button class="btn btn-google" type="button">
                <img src="../../../../assets/images/google.svg" alt="">
                Sign in with Google
              </button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-fb" type="button">
                <img src="../../../../assets/images/facebook.svg" alt="">
                Sign in with FB
              </button>
            </div>
          </div>
        </div> -->
        <p class="recaptcha">
          Subject to the LuQta
          <a [href]="baseUrl + '/terms-conditions'" target="_blank">{{ 'login.terms-conditions' | translate }}</a>
          and
          <a [href]="baseUrl + '/privacy-policy'" target="_blank">{{ 'login.privacy-policy' | translate }}</a>.
        </p>
      </div>
    </form>

    <div class="download-app">
      <div class="row">
        <div class="col-lg-7">
          <h3>
            {{ 'login.download-heading' | translate }}
            <br>
            {{ 'login.download-subheading' | translate }}
          </h3>
        </div>
        <div class="col-lg-5">
          <div class="app-buttons">
            <a href="https://apps.apple.com/qa/app/luqta/id6752577067">
              <img src="../../../../assets/images/apple.svg" class="app-btn" alt="" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=io.luqta.application">
              <img src="../../../../assets/images/android.svg" class="app-btn" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Registaration -->